var jQuery = require('jquery');
var $ = jQuery;
global.$ = jQuery;
global.jQuery = jQuery;
global.jquery = jQuery;

var slick = require('slick-slider');

var fancybox = require('fancybox')($);
global.fancybox = fancybox;

var Cookies = require('js-cookie');
global.Cookies = Cookies;

require('bootstrap/js/dist/util');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/collapse');